import { z } from 'zod';
import { IsoDate, Money } from './common';

export const TripStatus = z.enum(['planejando', 'comprada', 'arquivada']);
export type TripStatus = z.infer<typeof TripStatus>;

const TripFields = z.object({
  name: z.string().trim().min(1, 'Dê um nome para a viagem.').max(80),
  startDate: IsoDate.nullable().optional(),
  endDate: IsoDate.nullable().optional(),
  notes: z.string().trim().max(500).nullable().optional(),
});

const datesInOrder = (v: { startDate?: string | null; endDate?: string | null }) =>
  !v.startDate || !v.endDate || v.startDate <= v.endDate;
const datesMessage = { message: 'A volta precisa ser depois da ida.', path: ['endDate'] };

export const TripInput = TripFields.refine(datesInOrder, datesMessage);
export type TripInput = z.infer<typeof TripInput>;

export const TripUpdate = TripFields.partial()
  .extend({ status: TripStatus.optional() })
  .refine(datesInOrder, datesMessage);
export type TripUpdate = z.infer<typeof TripUpdate>;

export const Trip = z.object({
  id: z.string(),
  name: z.string(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  notes: z.string().nullable(),
  status: TripStatus,
  routeCount: z.number().int(),
  /** Soma dos menores preços atuais das rotas ativas da viagem, quando todas têm preço. */
  bestTotal: Money.nullable(),
  createdAt: z.string(),
});
export type Trip = z.infer<typeof Trip>;

export const TripList = z.object({ trips: z.array(Trip) });
export type TripList = z.infer<typeof TripList>;
